/**
 * @module app.um
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { IPopup } from 'app/shared/elements/popup-base';
import { validate } from 'app/shared/elements/ess-rule';
import { TransportationAppointmentGrid, AuthAppointmentEvent } from 'app/um/components/auth/transportation/transportation-appointment-grid';
import { deepClone, safe } from 'app/shared/lib/utilities';
import { FormSuccessCustomEvent } from 'app/shared/elements/forms/ess-form';
import { Toaster } from 'app/shared/lib/toaster';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class Transportation extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.toView })
    public auth!: UM.Auth;
    @bindable.boolean({ defaultBindingMode: bindingMode.toView })
    public readonly: boolean = true;

    protected authId: string | null = null;
    protected memberId: string | null = null;

    protected validate = validate;

    /** Prevents the modal's form from going through its lifecycle until the modal is opened */
    protected loadModal: boolean = false;

    /** The appointment used by save-appointment (modal form). null = new appointment */
    protected saveAppointment: UM.AuthTransportationAppointment | null = null;


    ////****************** Element References ***************************************////
    protected $form!: IForm;
    protected $modal!: IPopup;
    protected $grid!: TransportationAppointmentGrid;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(private readonly toaster: Toaster, ...rest: any[]) {
        super(...rest);
    }

    protected bind(bindingContext: Object, overrideContext: Object): void {
        if(!this.auth) {
            throw new Error("Missing required bindable property [auth]");
        }
        this.authId = this.auth.id || null;
        this.memberId = safe(() => this.auth.member!.id) || null;
    }


    ////****************** Events ***************************************************////
    protected formSuccess({ detail }: FormSuccessCustomEvent): void {
        this.toaster.standard.saved('um:auth.transportationAppointment.$', true);
        this.$modal.close();

        if(detail.form && detail.form.reset) {
            detail.form.reset();
        }

        this.reload();
    }


    ////****************** Functions ************************************************////
    public async reload(): Promise<void> {
        if(this.$grid) {
            this.$grid.reload();
        }
    }

    protected newAppointment(): void {
        this.saveAppointment = null;
        this.loadModal = true;
        this.$modal.open();
    }

    protected openAppointment(event: AuthAppointmentEvent, copy: boolean = false): void {
        if(event && event.detail && event.detail.appointment) {
            this.saveAppointment = deepClone(event.detail.appointment);
            if(this.saveAppointment) {
                if(copy) { this.saveAppointment.id = null; }
                this.loadModal = true;
                this.$modal.open();
            }
        }
    }

    ////****************** Service Calls ********************************************////

}
